import React from "react";
import { ReferenceInput, SelectInput, required } from "react-admin";

const SportCodeInput = () => (
  <ReferenceInput label="Sport" source="sportCode" reference="sportCodes">
    <SelectInput
      optionText="label"
      optionValue="code"
      validate={[required()]}
    />
  </ReferenceInput>
);

export default SportCodeInput;
